import LoadingButton from "@mui/lab/LoadingButton";
import * as Yup from "yup";
import { useFormik } from "formik";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { API_URL, ConvertToMiladiDateDB } from "../../utilities";
import { useAuth } from "../../context/auth";
import { useNotifications } from "@toolpad/core/useNotifications";
import React, { useEffect } from "react";
import TransactionForm from "./components/transaction-form";
import { getRoutes } from "src/utilities/routes";
import { ITransaction } from "src/interface/ITransaction";
import { TransactionType } from "src/interface/enum/TransactionType";
const validationSchema = Yup.object({
  customerRef: Yup.string().required("این فیلد الزامی است"),
  transactionDate: Yup.string().required("این فیلد الزامی است"),
  amount2: Yup.string().required("این فیلد الزامی است"),
});

const initialValues: ITransaction = {
  agreementId: undefined,
  customerRef: undefined,
  creatorRef: undefined,
  transactionDate: new Date(),
  description: "",
  amount: undefined,
  amount2: undefined,
  isDebit: true,
  transactionType: TransactionType.Manual,
};

const NewTransaction = ({
  open,
  handleClose,
  refetch,
  customerRef,
}: {
  open: boolean;
  handleClose: () => void;
  refetch: () => void;
  customerRef?: string;
}) => {
  const { user } = useAuth();
  const Reoutes = getRoutes();

  // تنظیم مقادیر اولیه با در نظر گرفتن customerRef
  const getInitialValues = (): ITransaction => ({
    agreementId: undefined,
    customerRef: customerRef || undefined,
    creatorRef: undefined,
    transactionDate: new Date(),
    description: "",
    amount: 0,
    amount2: undefined,
    isDebit: true,
    transactionType: TransactionType.Manual,
  });
  const { mutateAsync: insertAsync, isPending } = useMutation({
    mutationFn: async (body: any) => {
      const response = await fetch(Reoutes.TransactionRoutes, {
        method: "POST",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify(body),
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const notifications = useNotifications();

  const formik = useFormik<ITransaction>({
    initialValues: initialValues, // مقادیر اولیه فرم
    validationSchema, // schema اعتبارسنجی
    enableReinitialize: true, // اجازه به‌روزرسانی مقادیر اولیه
    onSubmit: async (values) => {
      const amount =
        typeof values.amount2 === "string"
          ? parseInt((values.amount2 as string).replace(/[^\d]/g, "")) || 0
          : values.amount2;
      // اطمینان از اینکه amount به درستی عدد باشد
      const processedValues = {
        ...values,
        amount: amount,
        transactionDate: ConvertToMiladiDateDB(
          values.transactionDate?.toString() ?? ""
        ),
      };

      const res = await insertAsync(processedValues);
      if (res.status === true) {
        notifications.show("تراکنش با موفقیت ثبت شد!", {
          key: "new-task",
          severity: "success",
          autoHideDuration: 5000,
        });

        refetch();
        handleClose();
      } else {
        notifications.show("خطا در ذخیره سازی!", {
          key: "err-task",
          severity: "error",
          autoHideDuration: 5000,
        });
      }
      formik.resetForm();
    },
  });

  // به‌روزرسانی customerRef در فرم وقتی تغییر می‌کند
  useEffect(() => {
    if (customerRef && customerRef !== formik.values.customerRef) {
      formik.setFieldValue("customerRef", customerRef);
      formik.setFieldTouched("customerRef", true);
    }
  }, [customerRef, formik]);

  // ریست کردن فرم وقتی دیالوگ باز می‌شود
  useEffect(() => {
    if (open) {
      formik.resetForm({ values: getInitialValues() });
    }
  }, [open, customerRef]);

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        PaperProps={{
          component: "form",
          onSubmit: formik.handleSubmit,
          sx: {
            width: "100%",
          },
        }}
      >
        <DialogTitle>تراکنش جدید</DialogTitle>
        <DialogContent>
          <TransactionForm formik={formik} customerRef={customerRef} />
        </DialogContent>
        <DialogActions>
          <LoadingButton
            loading={isPending}
            variant="contained"
            color="success"
            size="medium"
            fullWidth
            type="submit"
          >
            ذخیره
          </LoadingButton>
          <Button color="error" variant="contained" onClick={handleClose}>
            انصراف
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default NewTransaction;
